module.exports = __webpack_public_path__ + "media/stylesheets/images/rausi_krossinn_16x16-78f9ed68b4c72dc1ac3a703eadfd90b9.ico";